import { SelectionChangedEvent } from "ag-grid-community";
import { TaxMappingEntity } from "domain/entity/TaxMapping/TaxMappingEntity";
import _ from "lodash";
import { INITIAL_TAX_MAPPING_COL_DEF } from "presentation/constant/TaxMapping/TaxMappingColumnDefinition";
import { useTaxMappingVM } from "presentation/hook/TaxMapping/useTaxMappingVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useTaxMappingTracked } from "presentation/store/TaxMapping/TaxMappingProvider";
import RightClickMenuWithMoveAfter from "presentation/view/components/NbisRightClickMenu/RightClickMenuWithMoveAfter";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { createRef, memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";
const TaxMappingTablePanel = () => {
    const gridRef: any = useRef(null);
    const [taxMappingState] = useTaxMappingTracked();
    const taxMappingVM = useTaxMappingVM();
    const messageBarVM = useMessageBarVM();

    // const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [anainfoState] = useANAInfoTracked();
    const { allowUpdate } = anainfoState;
    const rightClickRef: any = createRef();
    // for right click menu with move after begin
    const [showMoveCursor, setShowMoveCursor] = useState<boolean>(false);
    const [allRows, setAllRows] = useState<TaxMappingEntity[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [initialAllRows, setInitialAllRows] = useState<boolean>(true);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        // setOnTableSelectionClicked(true);
        taxMappingVM.updateSelectedRows(selectedRows);
    }, [taxMappingVM])

    // const handleRowDrag = useCallback((e: any, updatedRows: TaxMappingEntity[], movedIndex: number, overIndex: number)=>{
    //     taxMappingVM.onRowDrag(updatedRows);
    // },[taxMappingVM])


    const handleRowDoubleClick = useCallback((entity: TaxMappingEntity) => {
        // if(updatedRows.length > 0){
        //     messageBarVM.showError("Modified data has not been saved.Please save or refersh the data first."); 
        //     return;
        // }
        taxMappingVM.onRowDoubleClick(entity);
    }, [taxMappingVM])

    const getAllRows = useCallback(() => {
        return allRows;
    }, [allRows]);

    const getSelectedRows = useCallback(() => {
        return taxMappingState.selectedRows;
    }, [taxMappingState.selectedRows]);

    // const getShowMoveCursor = useCallback(() => {
    //     return showMoveCursor;
    // }, [showMoveCursor]);
    // //for right click menu with move after end

    // useEffect(() => {
    //     //const columnDefs = (INITIAL_TAX_MAPPING_COL_DEF?.slice());

    //     if (!taxMappingState.selectedRows || taxMappingState.selectedRows.length <= 0) {
    //         //gridRef.current?.gridRef.current.api?.setColumnDefs(columnDefs);
    //         if (!onTableSelectionClicked) {
    //             gridRef.current?.gridRef.current.api?.deselectAll();
    //         }
    //     }
    //     changeCursor("tax-mapping-table", getShowMoveCursor());
    // });

    // useEffect(() => {
    //     if (!onTableSelectionClicked) return;
    //     gridRef?.current?.gridRef.current.api?.deselectAll();
    //     changeCursor("tax-mapping-table", getShowMoveCursor());
    // }, [getShowMoveCursor, onTableSelectionClicked]);

    useEffect(() => {
        const handleRightClickMenu = (event: any) => {
            if (_.isEmpty(taxMappingState.selectedRows) || !allowUpdate) {
                return;
            }
            event.preventDefault();
            rightClickRef.current.show(event);
        };
        document.getElementById('myDiv')?.addEventListener("contextmenu", handleRightClickMenu);

        return () => {
            document.getElementById('myDiv')?.removeEventListener("contextmenu", handleRightClickMenu);
        };
    }, [messageBarVM, rightClickRef, allowUpdate, taxMappingState.selectedRows]);

    // for right click menu with move after begin
    const onRefreshRow = useCallback((newAllRows: any[]) => {
        setAllRows(newAllRows);
        taxMappingVM.updateSelectedRows([]);
        setShowMoveCursor(true);
    }, [taxMappingVM]);

    const onMoveCancel = useCallback(() => {
        setInitialAllRows(true);
        let list = taxMappingState.taxMappingList?.map(taxMappingEntity => {
            return {
                ...taxMappingEntity,
                percentagestr: taxMappingEntity?.percentage?.toFixed(2)
            }
        })
        setAllRows(list);
        taxMappingVM.updateSelectedRows([]);
        setShowMoveCursor(false);
    }, [taxMappingState.taxMappingList, taxMappingVM]);

    const onSaveMove = useCallback(async (newAllRows: any[]) => {
        if (_.isEmpty(newAllRows)) return;

        setIsLoading(true);

        taxMappingVM.onApply(newAllRows).then((res) => {
            if (!res || !res.success) {
                messageBarVM.showError('Move failed.');
                setInitialAllRows(true);
                setIsLoading(false);

                taxMappingVM.updateSelectedRows([]);
                setShowMoveCursor(false);
            } else {
                taxMappingVM.searchAllTaxMappingList().then((data) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    taxMappingVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                }).catch((e) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    taxMappingVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                })
            }
        })
    }, [messageBarVM, taxMappingVM]);

    const memoTaxMappingTable = useMemo(() => {

        return (
            <>
                {(allowUpdate) && <RightClickMenuWithMoveAfter disabled={_.isEmpty(getSelectedRows())}
                    rightClickRef={rightClickRef} selectedRows={getSelectedRows()} allRows={getAllRows()}
                    onSaveMove={onSaveMove} onCancel={onMoveCancel} onRefreshRow={onRefreshRow}
                    showConfirmMove={showMoveCursor} priorityName="priority" />}
                <div id="myDiv">
                    <NbisTable
                        id='tax-mapping-table'
                        isNewColumnSetting={true}
                        columns={INITIAL_TAX_MAPPING_COL_DEF}
                        data={allRows ?? []}
                        showPaginator={false}
                        editable={false}
                        showAddIcon={false}
                        showDeleteButton={false}
                        showReloadIcon={false}
                        isScrollHighlighted={true}
                        selectionMode={false}
                        isRowHighligted={true}
                        handleSelectionChanged={handleSelectionChange}
                        onRowDoubleClick={(e: any, entity: TaxMappingEntity) => handleRowDoubleClick(entity)}
                        gridHeight="customHeight"
                        customHeight="calc(100vh - 125px)"
                        ref={gridRef}
                        // isRowDrag={true}
                        // onRowDragged={handleRowDrag}
                        rowSelection={showMoveCursor ? "single" : "multiple"}
                        // onBodyScroll={(e: any) => changeCursor("tax-mapping-table", getShowMoveCursor())}
                        showCutCursor={showMoveCursor}
                    />
                </div>
            </>
        );
    }, [allowUpdate, getSelectedRows, rightClickRef, getAllRows, onSaveMove, onMoveCancel, onRefreshRow, showMoveCursor, allRows, handleSelectionChange, handleRowDoubleClick])

    useEffect(() => {
        if (initialAllRows && taxMappingState.taxMappingList && !_.isEmpty(taxMappingState.taxMappingList)) {
            setAllRows(taxMappingState.taxMappingList.map((taxMappingEntity, index) => ({
                ...taxMappingEntity,
                percentagestr: taxMappingEntity?.percentage?.toFixed(2),
                index: index || 0
            })));
            setInitialAllRows(false);
        }
    }, [allRows, initialAllRows, taxMappingState.taxMappingList]);

    return <><TableWrapper>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        {memoTaxMappingTable}
    </TableWrapper>
    </>;
}

export default memo(TaxMappingTablePanel);
